/** -1 = Hidden, 0 = Read (show but no write), 1 = Write */
export type VisibilityLevel = -1 | 0 | 1;

export const VISIBILITY_LEVEL = {
    HIDDEN: -1 as const,
    READ: 0 as const,
    WRITE: 1 as const,
} as const;

export const VISIBILITY_KEYS = {
    DATA_PENDING: {
        ENABLED: 'dataPending.enabled',
        ADD_CLARIFICATION: 'dataPending.addClarification',
        AICA_CHASE: 'dataPending.aicaChase',
        COMPOSE_EMAIL: 'dataPending.composeEmail',
        SELECT_LINE_ITEM: 'dataPending.selectLineItem',
        THREE_DOTS: 'dataPending.threeDots',
        USER_LIST: 'dataPending.userList',
        UPDATED_DURATION: 'dataPending.updatedDuration',
        MARK_AS_COMPLETED: 'dataPending.markAsCompleted',
    },

    DEBT_PRODUCT: {
        ENABLED: 'debtProduct.enabled',
        ACCORDION: 'debtProduct.accordion',
        SELECT_PRODUCT: 'debtProduct.selectProduct',
        SELECT_LENDER: 'debtProduct.selectLender',
        EDIT_PROFILE: 'debtProduct.editProfile',
        SHOW_IMPORTANCE_COLUMN: 'debtProduct.showImportanceColumn',
        SHOW_PEC_VALUES: 'debtProduct.showPecValues',
    },
    LENDER_MANAGEMENT: {
        SUMMON: 'lender.summon',
        MANAGE_INVESTORS: 'lender.manage',
    },

    PARTNER_MANAGEMENT: {
        MANAGE_PARTNERS: 'partner.manage',
    },

    MAGIC_UPLOAD: {
        ENABLED: 'magicUpload.enabled',
    },

    MAGIC_SIGN: {
        ENABLED: 'magicSign.enabled',
        GLOBAL: 'magicSign.global',
        SHOW_SIGNED_COPY: 'magicSign.showSignedCopy',
    },

    HELP_CENTER_CTA: {
        ENABLED: 'helpCenter.cta.enabled',
    },

    MANDATE_CREATION: {
        CREATE_DEAL: 'mandateCreation.enabled',
        MODAL: 'mandateCreation.modal',
        CONFIRMATION_MODAL: 'mandateCreation.confirmationModal',
    },

    DEAL_SHARE: {
        ENABLED: 'deal.share.enabled',
    },

    NOTIFICATION_MODAL: {
        ENABLED: 'notification.modal',
    },
    NOTIFICATION_BELL: {
        ENABLED: 'notification.bell.enabled',
    },
    DATA_TABLE: {
        DEALS_FIELD_UPDATE: 'dataTable.deals.field.update',
        LEADS_FIELD_UPDATE: 'dataTable.leads.field.update',
        MANDATE_FIELD_UPDATE: 'dataTable.mandate.field.update',
    },
    UNLOCK_AICA: {
        ENABLED: 'unlockAica.enable',
    },
    QUALIFICATION_CHECKS: {
        ENABLE: 'qualificationChecks.enable',
    },
    SIDEBAR: {
        RELATED_NETWORK_ENABLE: 'sidebar.relatedNetwork.enable',
    },
    LOOKALIKE: {
        ENABLED: 'lookalike.enabled',
    },
    DATA_ROOM: {
        DOWNLOAD: 'data.room.download',
    },
    BANKING: {
        EXTRACT_NOW: 'banking.extractNow',
    },
    MODULE_SUMMARY: {
        ENABLED: 'module.summary.enabled',
    },
    USER_MANAGEMENT: {
        EDIT_USER_ROLE: 'userManagement.editUserRole',
    },
    LENDER_USER_TYPE_MANAGEMENT: {
        EDIT_LENDER_USER_TYPE: 'lenderUserTypeManagement.editLenderUserType',
    },
    // ─── Plate-based rich-text editor rollouts ──────────────────────────────
    // Each of these toggles a feature between its legacy Slate-based
    // implementation (flag absent / 0) and a new PlateEditor-powered V2
    // (flag = 1). Missing-key default = hide V2 (legacy stays).
    ONE_PAGER: {
        V2: 'editor.onePager.v2',
    },
    ENGAGEMENT_LETTER: {
        V2: 'editor.engagementLetter.v2',
    },
    NDA: {
        V2: 'editor.nda.v2',
    },
    BUREAU_KYC_CONSENT: {
        V2: 'editor.bureauKycConsent.v2',
    },
    // Granular gate for AI-assistant features inside the Plate editor
    // (⌘J prompt menu, AI toolbar button). Independent of the V2 flags —
    // you can ship the new editor without AI by setting onePager.v2 = 1
    // and AI.enabled = 0.
    AI: {
        ENABLED: 'editor.AI.enabled',
    },
    LEAD: {
        ARCHIVE_ENABLED: 'lead.archive.enabled',
        BULK_ADD_REROUTE_ENABLED: 'lead.bulkAddReroute.enabled',
    },
    PLATFORM_CONFIG: {
        MANAGE_FIELDS: 'platformConfig.manageFields',
    },
    REPORTS: {
        ADD_TO_REPORTS: 'reports.addToReports',
    },
    // Fail-closed opt-in (RECUR-27376 §C): missing key ⇒ disabled. See
    // useVisibilityConfig().isExplicitlyEnabled — do NOT gate this with getLevel/isVisible,
    // whose missing-key default is READ (fail-open) and would show it for every PNO.
    PORTFOLIO_ASK_AICA: {
        ENABLED: 'portfolioAskAica.enabled',
    },
} as const;
